import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { IMG_URL, LIST_TYPEVOTE } from "../../constant";
import {
  resetState,
  selectCurrentTownData,
  selectGu,
  selectSi,
} from "../../store/appSlice";
import {
  CardNotMoving,
  Title,
  VoteTypeTitle,
  WrapArtlcle,
  WrapCards,
  WrapTitle,
} from "../style/styled";
import { CompBtnBack, CompBtnMore } from "./CompIconBtn";
import { CompMore } from "./CompMore";
import { CompTextBrief } from "./CompText";

export function PageGetResult() {
  const dispatch = useDispatch();
  const currentSi = useSelector(selectSi);
  const currentGu = useSelector(selectGu);
  const { category, votePeopleNum_19, voteNumRank_19 } = useSelector(
    selectCurrentTownData
  );
  const [isMoreContent, setIsMoreContent] = useState(false);
  const onMoreContent = () => {
    setIsMoreContent(true);
  };
  const onPrevStep = () => {
    dispatch(resetState());
  };

  useEffect(() => {
    if (isMoreContent) {
      const moveToHeight = window.innerHeight - 100;
      document.getElementById("content").scrollTo(0, moveToHeight);
    }
  }, [isMoreContent]);

  return (
    <>
      <CompBtnBack onClick={onPrevStep} />
      <WrapCards>
        <CardNotMoving>
          <img
            src={`${IMG_URL}/card_${category}.png`}
            alt="우리동네 대선이야기 카드 이미지"
          />
        </CardNotMoving>
      </WrapCards>
      <WrapArtlcle>
        <WrapTitle>
          <Title>
            {currentSi} {currentGu}
          </Title>
          <VoteTypeTitle>{LIST_TYPEVOTE[category]}</VoteTypeTitle>
        </WrapTitle>
        <CompTextBrief
          voting={LIST_TYPEVOTE[category]}
          town={`${currentSi} ${currentGu}`}
          votePeopleNum_19={votePeopleNum_19}
          voteNumRank_19={voteNumRank_19}
        />
        <CompBtnMore onClick={onMoreContent} />
        {isMoreContent && <CompMore />}
      </WrapArtlcle>
    </>
  );
}
